// extracted by mini-css-extract-plugin
module.exports = {"slideshowExitHint":"main_slideshowExitHint__3lGpR","slideshowArrowHint":"main_slideshowArrowHint__1bhWt","icon":"main_icon__10Ulm"};